import type {User} from '@gaia/types';
import {isOptedOut} from '@gaia/utils/gaia/trackAnalytics';
import {useFlags, useLDClient} from 'launchdarkly-react-client-sdk';
import {useEffect} from 'react';

export interface LDFlagSet {
    [key: string]: any;
}

interface LDUser {
    key?: string;
    secondary?: string;
    name?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    avatar?: string;
    ip?: string;
    country?: string;
    anonymous?: boolean;
    custom?: {
        [key: string]: string | boolean | number | Array<string | boolean | number>;
    };
    privateAttributeNames?: Array<string>;
}

interface LDClient {
    identify(
        user: LDUser,
        hash?: string,
        onDone?: (err: Error | null, flags: LDFlagSet | null) => void
    ): Promise<LDFlagSet>;
}

export default function useLaunchDarkly(user: User) {
    const ldClient: LDClient | undefined = useLDClient();

    useEffect(() => {
        if (ldClient === undefined) return;

        // skip LaunchDarkly user identification for anonymous (id `null`) and tracking opted-out users
        if (user.id === null || isOptedOut(user)) return;

        ldClient.identify({key: `${user.id}`}).catch(console.error);
    }, [ldClient, user]);

    return useFlags();
}
